import styled, { css } from 'styled-components';
import flash from '~/assets/icons/flash.svg';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { orderItemColors } from './AppTruckJobOrderItem.model';

const StyledContainer = styled.div<{ $level: number; $active?: boolean }>`
	position: relative;
	display: grid;
	grid-template-columns: 80px 11px 1fr 40px;
	align-items: center;
	width: 100%;
	height: 100px;
	min-height: 100px;
	padding: 0 20px 0 10px;
	background-color: ${({ $level }) => orderItemColors[$level - 1].bg};
	border: 1px solid ${({ $level }) => orderItemColors[$level - 1].border};
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	${({ $active }) =>
		$active &&
		css`
			background-color: #2d70da;

			${StyledNameContainer} {
				.dec {
					background-color: #ffffff;
				}
			}
		`}
`;

const StyledDec = styled.div<{ $level: number }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	background-color: ${({ $level }) => orderItemColors[$level - 1].dec};
	mask-image: url(${flash});
	mask-size: 100% 100%;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${flash});
	-webkit-mask-size: 100% 100%;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
`;

const StyledImageContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;

	img {
		z-index: 2;
	}
`;

const StyledDividers = styled.div`
	display: flex;
	height: 60px;
	margin-left: 9px;
`;

const StyledInfoContainer = styled.div`
	height: 100%;
	margin-left: 20px;
`;

const StyledNameContainer = styled.div<{ $level: number }>`
	display: flex;
	align-items: center;
	gap: 6px;
	margin-top: 17px;

	${Text} {
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
	}

	.dec {
		width: 10px;
		height: 10px;
		mask-image: url(${flash});
		mask-size: 100% 100%;
		mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-image: url(${flash});
		-webkit-mask-size: 100% 100%;
		-webkit-mask-repeat: no-repeat;
		-webkit-mask-position: center;
		background-color: ${({ $level }) => orderItemColors[$level - 1].color};
		transition: background-color 0.3s ease;
	}
`;

const StyledInfoBottomContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	margin-top: 15px;

	${Divider} {
		height: 14px;
		opacity: 0.1;
	}
`;

const StyledInfoBottomItem = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	img {
		width: 14px;
		height: 14px;
		opacity: 0.5;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledDec,
	StyledDividers,
	StyledImageContainer,
	StyledInfoBottomContainer,
	StyledInfoBottomItem,
	StyledInfoContainer,
	StyledNameContainer,
};
